import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Loader from '@node-space/storybook-components/dist/Loader'
import { PageHeader } from '@node-space/storybook-components/dist/PageHeader'
import { StatusCard } from '@node-space/storybook-components/dist/StatusCard'
import { TextAction } from '@node-space/storybook-components/dist/TextAction'
import { Box, Text, Box as Wrapper } from '@node-space/ui-components'
import { RequestError } from 'components/Errors/RequestError'
import { useWalletContext } from 'hooks/context/useWalletContext'
import { useChannelsQuery, useSupportedCurrenciesQuery } from 'hooks/queries'
import ChannelsTable from 'pages/ManageChannels/components/ChannelsTable'
import { Pagination } from 'pages/ManageChannels/components/Pagination'
import { pageListOptions } from 'pages/ManageChannels/constants/contants'
import {
  AmplitudeEvent,
  AmplitudeEventAction,
  AmplitudeEventCategory,
} from 'utils/amplitude/amplitudeEvents'
import track from 'utils/tracker'
import { ChannelsHeaderButtons } from './components/ChannelsHeaderButtons'

export const ReceiveCrypto = () => {
  const { t } = useTranslation()
  const wallet = useWalletContext()
  const { data: currencies, isPending: isCurrenciesLoading } = useSupportedCurrenciesQuery()
  const [page, setPage] = useState(0)
  const [nrOfRows, setNrOfRows] = useState(pageListOptions[0].value)
  const [offset, setOffset] = useState(0)
  const {
    data: { channels = [], paging } = {},
    isFetching: isChannelsFetching,
    isError: isChannelsError,
    refetch: refetchChannels,
  } = useChannelsQuery({
    max: Number(nrOfRows),
    offset,
    search: '',
    walletId: String(wallet?.lsid),
  })

  useEffect(() => {
    refetchChannels()
  }, [offset])

  useEffect(() => {
    track.Amp.track(AmplitudeEvent.MANAGE_CHANNEL, {
      category: AmplitudeEventCategory.MERCHANT_PORTAL,
      action: AmplitudeEventAction.VIEW,
    })
  }, [])

  const isLoading = isChannelsFetching || isCurrenciesLoading

  return (
    <Wrapper className="channels-container" paddingT={24}>
      <PageHeader
        description={
          <Box>
            <Text variant="heading-3">{t('payments.channels.receiveCryptoTitle')}</Text>
            <Text>{t('payments.channels.receiveCryptoDescription')}</Text>
          </Box>
        }
        renderRightSection={
          <ChannelsHeaderButtons
            refetchChannels={refetchChannels}
            secondaryAction
            showManageChannels={false}
          />
        }
      />

      {!channels?.length && isLoading && (
        <Box flex justify="center" className="mt-10">
          <Loader />
        </Box>
      )}

      {!channels?.length && !isLoading && (
        <StatusCard headline={t('noChannelsFound')}>
          <Text variant="body-text">
            {t('noChannelsCreateChannel')}{' '}
            <TextAction linkTo={process.env.CHANNELS_LEARN_MORE} text={t('learnMore')} />.
          </Text>
        </StatusCard>
      )}

      {!!channels?.length && (
        <>
          {isLoading && (
            <Box flex centerChildren className="mt-10">
              <Loader />
            </Box>
          )}
          {isChannelsError && (
            <Box className="mt-10">
              <RequestError />
            </Box>
          )}

          {!isLoading && !!channels?.length && !isChannelsError && (
            <>
              <ChannelsTable channels={channels} currencies={currencies} />
              {paging?.total > Number(pageListOptions[0].value) && (
                <Pagination
                  page={page}
                  setPage={setPage}
                  setOffset={setOffset}
                  pagination={paging}
                  nrOfRows={nrOfRows}
                  setNrOfRows={setNrOfRows}
                />
              )}
            </>
          )}
        </>
      )}
    </Wrapper>
  )
}
